var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { N0, N90, B100 } from '@atlaskit/theme/colors';
import React from 'react';
import styled from 'styled-components';
const RADIUS = 8;
const DIAMETER = 2 * RADIUS;
const BORDER_WIDTH = 2;
const WIDTH = 36;
export function Toggle(_a) {
    var { position, ariaLabel, ref, innerRef, backGroundColor, borderColor } = _a, props = __rest(_a, ["position", "ariaLabel", "ref", "innerRef", "backGroundColor", "borderColor"]);
    const isRight = position === 'right';
    return (React.createElement(Container, Object.assign({ role: "switch", "aria-checked": isRight, "aria-label": ariaLabel, innerRef: innerRef }, props),
        React.createElement(Track, { backGroundColor: backGroundColor, borderColor: borderColor },
            React.createElement(Thumb, { isRight: isRight }))));
}
const Container = styled.button `
  padding: ${BORDER_WIDTH}px;
  border: ${BORDER_WIDTH}px solid ${N90};
  border-radius: ${RADIUS + 3 * BORDER_WIDTH}px;
  border-color: transparent;
  box-sizing: content-box;
  outline: none;
  margin: 0 10px;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${B100};
  }
`;
const Track = styled.div `
  cursor: pointer;
  width: ${WIDTH}px;
  height: ${DIAMETER}px;
  border-radius: ${RADIUS + BORDER_WIDTH}px;
  background-color: ${({ backGroundColor }) => backGroundColor ? backGroundColor : N90};
  border: ${BORDER_WIDTH}px solid
    ${({ borderColor }) => (borderColor ? borderColor : N90)};
`;
const Thumb = styled.div `
  margin-left: ${({ isRight }) => (isRight ? WIDTH - DIAMETER : 0)}px;
  width: ${DIAMETER}px;
  height: ${DIAMETER}px;
  border-radius: ${RADIUS}px;
  background-color: ${N0};
  transition: margin-left 0.2s;
`;
//# sourceMappingURL=toggle.js.map